import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

import { trackByFactory } from '@mode/capra';

interface TreeNodeContext<T> {
  $implicit: T;
  level: number;
}

@Component({
  standalone: true,
  selector: 'mode-tree',
  imports: [CommonModule],
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeComponent<T> {
  /**
   * The item to render in the tree.
   */
  @Input() node: T | undefined;
  /**
   * The template of the node to pass into the tree.
   */
  @Input() template?: TemplateRef<TreeNodeContext<T> | null> | undefined | null = null;
  /**
   * **Do not modify**. Used internally to track number of levels of recursion and exposed via the template context.
   */
  @Input() level = 0;
  /**
   * Callback function that tells the tree how to retrieve the given node's unique ID.
   */
  @Input() getId: (node: T) => string = () => '';
  /**
   * Callback function that tells the tree how to retrieve the given node's children to recurse over, if it has any.
   */
  @Input() getChildren: (node: T) => T[] = () => [];

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public trackById = trackByFactory<T>(this.getId);
}
